import styled from "styled-components"

import tokens from "../_tokens"

const HorizontalRule = styled.hr`
  height: ${0.5 * tokens.size.base}px;
  padding: 0;
  margin: ${2.5 * tokens.size.base}px 0;
  background-color: ${tokens.color.bgLight};
  border: 0;
`

export default HorizontalRule
